import baseApi from '@store/api/baseApi';

export const brandProfileApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchClientsByBrand: builder.query({
			query: (params) => `/user/all-client${params}`,
			transformResponse: (response) => {
				if (response) {
					response.data = response?.data?.map((brand) => ({
						...brand,
						secondaryAccountManagers:
							brand?.accountManagers?.map((item) => ({ label: item.name, value: item.id })) ||
							[],
						fashionDesigners:
							brand?.designers?.map((item) => ({ label: item.name, value: item.id })) || [],
						bdm: brand?.bdm ? { label: brand?.bdm?.name, value: brand?.bdm?.id } : {},
						primaryAccountManager: brand?.accountExecutive
							? { label: brand?.accountExecutive?.name, value: brand?.accountExecutive?.id }
							: {}
					}));
				}
				return response;
			},
			providesTags: ['BRAND_PROFILE_CLIENTS']
		}),
		disableClientById: builder.mutation({
			query: ({ clientId, status }) => ({
				url: `/user/update-status/${clientId}`,
				method: 'POST',
				body: JSON.stringify(status),
				headers: { 'Content-Type': 'application/json' }
			}),
			invalidatesTags: ['BRAND_PROFILE_CLIENTS']
		}),
		updateClientById: builder.mutation({
			query: ({ clientId, requestBody }) => ({
				url: `/user/client/${clientId}/assign-team`,
				method: 'POST',
				body: requestBody
			}),
			invalidatesTags: ['BRAND_PROFILE_CLIENTS']
		}),
		assignMarketFabricCategoryByClientId: builder.mutation({
			query: ({ clientId, requestBody }) => ({
				url: `/user/client/${clientId}/map-market-fabric-category`,
				method: 'POST',
				body: requestBody
			}),
			invalidatesTags: ['BRAND_PROFILE_CLIENTS']
		}),
		removeMarketFabricCategoryByClientId: builder.mutation({
			query: ({ clientId, mapId }) => ({
				url: `/user/client/${clientId}/market-fabric-category-map/${mapId}`,
				method: 'DELETE'
			}),
			invalidatesTags: ['BRAND_PROFILE_CLIENTS']
		})
	})
});

export const {
	useLazyFetchClientsByBrandQuery,
	useDisableClientByIdMutation,
	useUpdateClientByIdMutation,
	useAssignMarketFabricCategoryByClientIdMutation,
	useRemoveMarketFabricCategoryByClientIdMutation
} = brandProfileApi;
